import { MultiValuedListMore } from '../../../MultiValuedList'

function RequestMultiValuedListMore(props) {
  return <MultiValuedListMore {...props} variant='tag' />
}

export default RequestMultiValuedListMore
